import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { Warehouse, WarehouseService } from '../../services/warehouse.service';

import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-update-warehouse',
  templateUrl: './update-warehouse.component.html',
  styleUrls: ['./update-warehouse.component.css']
})
export class UpdateWarehouseComponent implements OnInit, OnDestroy {

  warehouseForm: FormGroup;

  sid: string;
  warehouse: any;
  subsciptionWarehouse: Subscription;

  constructor(
    private warehouseService: WarehouseService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute
  ) {
    this.sid = this.activatedRoute.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.createForm();
    this.subsciptionWarehouse = this.warehouseService.getWarehouse(this.sid).subscribe(data => {
      this.warehouse = data;
      this.warehouseForm.get('name').setValue(data.name);
      this.warehouseForm.get('description').setValue(data.description);
      this.warehouseForm.get('folio').setValue(data.folio);
    });
  }

  ngOnDestroy() {
    this.subsciptionWarehouse.unsubscribe();
  }

  createForm() {
    this.warehouseForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      folio: ['', Validators.required]
    });
  }

  onSubmit({ value, valid }: { value: any, valid: boolean }) {
    this.warehouseService.updateWarehouse(this.sid, value);
  }

}
